import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { NpsActions } from 'actions'
import { NpsUtils } from 'utils'

@createStore(alt)
export default class NpsStore {
  static displayName = 'NpsStore'

  constructor() {
    const nps = localStorage.getItem('nps')
    if (nps) {
      const parsed = JSON.parse(nps)
      this.state = {
        npsDismissed: parsed.npsDismissed,
        npsScore: parsed.npsScore,
        npsShowAfter: parsed.npsShowAfter,
      }
    } else {
      this.state = {
        npsDismissed: false,
        npsScore: null
      }
    }

    this.bindActions(NpsActions)
  }

  updateLocalStorage() {
    localStorage.setItem('nps', JSON.stringify(this.state))
  }

  setDismissed(npsDismissed) {
    this.setState({ npsDismissed, npsShowAfter: NpsUtils.getReappearMoment() })
    this.updateLocalStorage()
  }

  setScore(npsScore) {
    this.setState({ npsScore })
    this.updateLocalStorage()
  }
}



// WEBPACK FOOTER //
// ./app/stores/NpsStore.js